module.exports = __webpack_public_path__ + "static/media/countries.34cea9bd.jpg";